module.exports = __webpack_public_path__ + "static/media/vip_room.187ff783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/VipRoom/images/vip_room.jpg
// module id = 438
// module chunks = 0